import FraudProfileItem from "./FraudProfileItem";

export default FraudProfileItem;